/**
 * Rutas del panel base (Starter / core). Lazy-load vía módulos soluqr/modules/*.
 */
import { dashboardRouteElements } from '@/soluqr/modules/dashboard/pages';
import {
  coreConfigRoute,
  coreMenuDesignRoute,
  coreMembershipRoute,
  coreQrRoute,
  coreSupportRoute,
} from '@/soluqr/modules/core/pages';
import { analyticsRouteElements } from '@/soluqr/modules/analytics/pages';
import { assistantRouteElements } from '@/soluqr/modules/assistant/pages';
import { customersRouteElements } from '@/soluqr/modules/customers/pages';
import { menuRouteElements } from '@/soluqr/modules/menu/pages';
import { ordersRouteElements } from '@/soluqr/modules/orders/pages';
import { solugoRouteElements } from '@/soluqr/modules/solugo/pages';

/** @type {Array<{ segment: string, element: import('react').ReactElement, moduleKey?: string }>} */
export const STARTER_DASHBOARD_ROUTE_ELEMENTS = [
  ...dashboardRouteElements,
  coreConfigRoute,
  coreMenuDesignRoute,
  ...menuRouteElements,
  ...customersRouteElements,
  ...ordersRouteElements,
  ...solugoRouteElements,
  coreQrRoute,
  coreMembershipRoute,
  ...analyticsRouteElements,
  coreSupportRoute,
  ...assistantRouteElements,
];
